import { useContext, type ReactNode } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import type { DestinationDealsCategory } from 'api/recommendations'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import GeoContext from 'contexts/geoContext'
import { isSeasonalCarouselMarket, SEASONAL_CAROUSEL_FILTERS, SEASONAL_CAROUSEL_LIMIT } from './seasonalCarouselConfig'
import useSeasonalCarouselList from './useSeasonalCarouselList'
import { HomepageOfferCarouselPassthrough } from './dedup/HomepageOfferCarousel'

export interface SeasonalOfferCarouselProps {
  offerList?: App.OfferList
  viewAllUrl?: string
}

interface Props extends SeasonalOfferCarouselProps {
  category: DestinationDealsCategory
}

function renderItalic(chunks: ReactNode) {
  return <i key="italic">{chunks}</i>
}

function SeasonalOfferCarousel({ category, offerList, viewAllUrl }: Props) {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)
  const { offerList: displayList } = useSeasonalCarouselList(category, offerList)

  if (!isSeasonalCarouselMarket(currentRegionCode)) return null

  let title: ReactNode
  if (category === 'longweekend') {
    title = intl.formatMessage({
      id: '04M7bfDU9xvHne_d6T3U',
      defaultMessage: 'The Quick <i>Escape</i>',
      description: 'Heading for the international short-break hotel carousel, with Escape emphasised in italics',
    }, { i: renderItalic })
  } else {
    title = intl.formatMessage({
      id: 'Kalpg_fCiiMjQdj9xDGA',
      defaultMessage: 'Chase the <i>Sun</i>',
      description: 'Heading for the international long-haul hotel carousel, with Sun emphasised in italics',
    }, { i: renderItalic })
  }

  return <HomepageOfferCarouselPassthrough>
    <OfferCardCarouselSection
      filters={SEASONAL_CAROUSEL_FILTERS}
      overrideOfferList={displayList}
      title={title}
      allLink={viewAllUrl}
      tileStyle="card-default"
      tileSize="medium"
      limit={SEASONAL_CAROUSEL_LIMIT}
      tabletLimit={SEASONAL_CAROUSEL_LIMIT}
      minimumOffersCount={4}
      data-testid={category === 'longhaul' ? 'chase-the-sun-carousel' : 'long-weekend-carousel'}
    />
  </HomepageOfferCarouselPassthrough>
}

export default React.memo(SeasonalOfferCarousel)
